import { useMutation, useQueryClient } from "@tanstack/react-query";

import { generateComplianceCSR } from "api/device.api";
import {
  invalidateDashboardSources,
  invalidateDeviceSide,
} from "lib/cacheInvalidation";

export const useGenerateComplianceCSR = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ deviceId, otp }) => generateComplianceCSR({ deviceId, otp }),
    onSuccess: () => {
      invalidateDeviceSide(queryClient);
      invalidateDashboardSources(queryClient);
    },
  });
};
